export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/mathletics-full-ae8a883d5008eb166de5eb59ad6a6ae7.svg";